<template>
    <div class="container">
        <div class="logo">
            <img :src="`/asset/logo.png`" alt="로고" />
            <p>지비오</p>
        </div>
        <div class="login-box">
            <div id="login-form">
                <div class="input-group">
                    <label for="user-type">구분</label>
                    <select id="user-type" v-model="userType" required>
                        <option value="O">단지관리자</option>
                        <option value="C">클라이언트</option>
                        <option value="A">에이전시</option>
                        <option value="S">수퍼바이저</option>
                    </select>
                </div>
                <div class="input-group">
                    <label for="id">아이디</label>
                    <input type="id" id="id" placeholder="아이디" v-model="id" required>
                    <small id="id-error" class="error-message">{{ idError }}</small>
                </div>
                <div class="input-group" style="margin-bottom: 5px !important;" >
                    <label for="password">패스워드</label>
                    <input type="password" id="password" placeholder="패스워드" v-model="password" required>
                    <small id="password-error" class="error-message">{{ passwordError }}</small>
                </div>
                <div class="forgot-password">
                    <label>
                        <input type="checkbox" v-model="autoLogin">
                        자동 로그인
                    </label>
                </div>
                <button class="submit-btn" v-on:click="loginButtonClick">로그인</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LoginView',
    data() {
        return {
            id: '',
            password: '',
            idError: '',
            passwordError: '',
            userType: 'O', //C
            autoLogin: false,
        };
    },
    methods: {
        validateForm() {
            this.idError = '';
            this.passwordError = '';

            if (!this.id) {
                this.idError = '아이디를 입력해주세요.';
            } 

            if (!this.password) {
                this.passwordError = '비밀번호를 입력해주세요.';
            }

            return !this.idError && !this.passwordError;
        },
        async loginButtonClick() {
          if (this.validateForm()) {
            let form = new FormData();
            form.append('id', this.id);
            form.append('pw', this.password);
            form.append('class', this.userType);

            try {
              const response = await this.$axios.post('/task/account_get_code.php', form);
              if (response.data.success) {
                let form1 = new FormData();
                form1.append('code', response.data.response_code);
                form1.append('class', this.userType);

                const complex = await this.getComplex(form1);
                const code = response.data.response_code;

                this.handleLogin(this.autoLogin, code, complex);
                this.$router.push("/");
              } else {
                this.idError = '구분 및 아이디 패스워드를 확인해주세요.';
              }
            } catch (e) {
              this.idError = '로그인 중 오류가 발생했습니다.';
            }
          }
        },
        async getComplex(formData) {
            const response = await this.$axios.post('/task/account_information_code.php', formData);
            console.log('account_information_code.php 응답:', response.data);
            return response.data?.result?.complex;
        },
        handleLogin(isAutoLogin, code, complex) {
          if (isAutoLogin) {
            // 자동로그인: 1년짜리 쿠키
            document.cookie = `loginCheck=true; path=/; max-age=${60 * 60 * 24 * 365}`;
            document.cookie = `complex=${complex}; path=/; max-age=${60 * 60 * 24 * 365}`;
            document.cookie = `code=${code}; path=/; max-age=${60 * 60 * 24 * 365}`;
          } else {
            // 세션 쿠키(브라우저 종료 시 삭제, max-age 없이)
            document.cookie = `loginCheck=true; path=/`;
            document.cookie = `complex=${complex}; path=/`;
            document.cookie = `code=${code}; path=/`;
          }
        }
    }
};
</script>
<style scoped>
body {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.container {
    width:100%;
    height:100%;
    padding: 70px;
}
.container .logo{
    position:relative;
    width:170px;
    height:auto;
    overflow:hidden;
    margin: 40px; 
}
.container .logo img {
    width: 60px;
    height: auto;
    float:left;
}
.container .logo p{
    position:absolute;
    bottom: 0;
    left: 70px;
    width: 70px;
    font-size:1rem !important;
    color: white;
    float:left;
}
.login-box {
    position:absolute;
    top:53%;
    transform: translateY(-50%);
    padding: 60px 40px;
    border-radius: 10px;
    width: 380px;
}
h2 {
    text-align: center;
    margin-bottom: 20px;
}
.input-group {
    margin-bottom: 25px;
    color:white;
}
.input-group label {
    display: block;
    margin-bottom: 5px;
    color: white;
    font-size: 1rem !important;
    font-weight: bold;
}
.input-group input {
    width: 100%;
    height: 40px;
    padding: 0 10px !important;
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: rgba(255,255,255,0.8) !important;
}
.input-group input:focus {
    border-color: #007bff;
    outline: none;
}
.input-group select {
    width: 100%;
    height: 40px;
    padding: 0 10px !important;
    border: 1px solid #ccc;
    border-radius: 4px;
    appearance: auto;           /* 기본 브라우저 스타일 사용 */
    -webkit-appearance: auto;   /* 크롬/사파리 */
    -moz-appearance: auto;      /* 파이어폭스 */
    background-color: rgba(255,255,255,0.8) !important;
    color:#666;
}
.input-group select:focus {
    border-color: #8fb3e2;
    outline: none;
}
.error-message {
    color: red;
    font-size: 0.875em;
}
.submit-btn {
    width: 100%;
    padding: 10px;
    background-color: #4cb4cf;
    border: none;
    margin-top:50px;
    border-radius: 4px;
    cursor: pointer;
}
.forgot-password {
    text-align: center;
    margin-bottom: 10px;
}
.signup-link {
    text-align: center;
    margin-top: 15px;
}
.signup-link a {
    color: #8fb3e2;
    text-decoration: none;
}
.signup-link a:hover {
    text-decoration: underline;
}
.forgot-password label {
    display: flex;
    align-items: center;
    color: white;
    font-size: 1rem !important;
}
.forgot-password input {
    margin-right: 5px;
}

</style>